import React from 'react';
import { BodyNormal } from '../../Typography';
import { ErrorTemplate } from '../ErrorTemplate';
import { locale } from '../locale';
import { StatusLink } from '../RedirectLinks';
import PartialOutageErrorSvg from './PartialOutageError.svg';
const getErrorContext = level => {
  if (level === 'global') {
    return {
      heading: locale.partialOutage.heading,
      errorMessage: locale.partialOutage.globalErrorMessage
    };
  }
  if (level === 'tile') {
    return {
      heading: locale.partialOutage.tileHeading,
      errorMessage: locale.partialOutage.errorMessage
    };
  }
  return {
    heading: locale.partialOutage.sectionHeading,
    errorMessage: locale.partialOutage.errorMessage
  };
};
export const PartialOutageError = props => {
  const contextError = getErrorContext(props.level);
  const isGlobal = props.level === 'global';
  const heading = props.heading || contextError.heading;
  const errorMessage = props.errorMessage || contextError.errorMessage;
  return /*#__PURE__*/React.createElement(ErrorTemplate, {
    heading: heading,
    image: PartialOutageErrorSvg,
    level: props.level
  }, /*#__PURE__*/React.createElement(BodyNormal, null, errorMessage, isGlobal && /*#__PURE__*/React.createElement(React.Fragment, null, ' ', locale.partialOutage.issuePersists, " ", /*#__PURE__*/React.createElement(StatusLink, null), " for updates.")));
};